export default __webpack_public_path__ + "static/wwf-webfont-a9ad7f8d5c593b5f7e84353f8c23dbb7.woff2";